import cn from 'clsx'

const KSClientPdfSplitLogsList = ({
    logs,
    loading,
}) => {
    
    return (
        
        <div className="logs grow-0">
            
            <ul className="flex flex-col gap-2">
                
                {logs.map((it, i) => {
                    
                    const isDivider = it.message === '----'
                    
                    return (
                        
                        <li
                            key={`log-${i}`}
                            className={cn('',
                                'px-2 py-1 rounded hover:bg-base-200/70', {
                                    'bg-base-200/50': (i % 2) === 0,
                                    'font-bold': i === 0 && loading,
                                },
                            )}>
                            
                            {!isDivider && (
                                <div className="text-xs font-mono">
                                    {it.timestamp}
                                </div>
                            )}
                            
                            <div className="text-sm">
                                {isDivider
                                    ? <hr className="h-px border-b border-base-300/50" />
                                    : it.message}
                            </div>
                        
                        </li>
                        
                    )
                    
                })}
            
            </ul>
        
        </div>
        
    )
    
}

export default KSClientPdfSplitLogsList
